import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { ErrorMessageType } from '@models/error-message-type.enum';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.less'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent {
  @Input() message: string;
  @Input() type: ErrorMessageType = ErrorMessageType.Error;
  @Input() set showCloseButton(value: boolean) {
    this._showCloseButton = value;
  }
  @Output() closed = new EventEmitter();
  private _showCloseButton: boolean = false;
  get showCloseButton() {
    return this._showCloseButton || this.closed.observers.length > 0;
  }
  errorMessageType = ErrorMessageType;

  constructor() {}
}
